// src/api/cadastrar.js
import { http, ApiError } from "./http";

export default async function newRequestUser(userData) {
  const url = `${process.env.REACT_APP_SERVER}/registration/request`;

  const payload = {
    fullName: userData.nomeCompleto,                 
    email: userData.email,
    cpf: userData.cpf,                               
    condominioCode: userData.condominioInfo?.trim(),
  };

  const data = await http(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!data?.message) {
    throw new ApiError({
      type: "CONTRACT",
      userMessage: "Resposta inválida do servidor.",
      data,
    });
  }

  return data;
}
